import { getCurrentUser } from 'data/auth/selectors'
import { RootState } from 'duck/store'
import { connect } from 'react-redux'
import { loginWithEmail } from 'scenes/Account/duck/actions'
import { getAccountPageState } from 'scenes/Account/duck/selectors'

import EmailLoginForm from './presentational'

function mapStateToProps(state: RootState) {
  const currentUser = getCurrentUser(state)
  const { isLoading, emailAuthError } = getAccountPageState(state)
  return {
    userLoggedIn: currentUser !== null,
    isLoading,
    authError: !!emailAuthError,
  }
}

export default connect(mapStateToProps, {
  onSubmit: loginWithEmail.request,
})(EmailLoginForm)
